export class PriceFormatValueConverter {
    toView(numericValue, includeDecimals = false) {
        if (numericValue === undefined || numericValue == null) {
            return '';
        }
        // value: 52900
        // value 0
        numericValue = Math.ceil(numericValue / 100) * 100;
        var value = numericValue.toString();
        if (includeDecimals == false) {
            if (value == '0' ) return value;
            return value.substr(0, value.length - 2);
        } else {
            if (value == '0' ) return value + ',00';
            return value.substr(0, value.length - 2) + ',' + value.substr(value.length - 2);
        }
    }
}
